module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-3 narrow-container"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('reset.title')))])]), _vm._v(" "), _c('form', {
    ref: "resetUserForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetUser($event)
      }
    }
  }, [(_vm.tokenValid) ? _c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.changePassword')
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "activation-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.newPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.confirmPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.0')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.1')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.2')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.3')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": !_vm.user.password || !_vm.user.newPassword || _vm.load
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('userAdministration.apply')) + "\n              "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d13c8784", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d13c8784","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activation/Reset.vue
// module id = 806
// module chunks = 1